module.exports = __webpack_public_path__ + "img/hello-mobile.efd6902b.jpg";